import React from 'react';
import {Button, Container, Alert} from 'react-bootstrap';
import {SubscriptionPricingTable, createBillingPortalSession} from './billing';

export default function DisabledPage(): React.JSX.Element {
  return (
    <Container className='my-5'>
      <Alert variant='warning'>
        <h1>Account disabled</h1>
        <p>
          Your subscription/trial has ended or there is an issue with billing.
          Please resubscribe or fix the billing issue to enable access to the
          service. If you resubscribed/fixed payment issues through the Payment
          portal then you'll need to logout and log back in to be able to access
          the service.
        </p>
        <Button
          variant='primary'
          onClick={() => {
            void createBillingPortalSession();
          }}
        >
          Payment Portal
        </Button>
      </Alert>

      <SubscriptionPricingTable showTrial={false} />
    </Container>
  );
}
